import './publicPath'

const Vue = window.Vue

Vue.component('VariationCrossSelling', () => import('./VariationCrossSelling.vue'))
